module.exports = __webpack_public_path__ + "img/cover.901c1d14.png";